import {RepositoryFactory} from '@/api/factory/repositoryFactory'
const ccSubmissionRepository = RepositoryFactory.get('ccSubmission')
import get from 'lodash-es/get'
const state = {
  item: null,
  itemLogs: [],
  // leaderboard
  items: [],
  count: 0,
  // submissions
  submissions: [],
  submissionCount: 0,
}
const actions = {
  async fetchOneSubmission({commit}, id) {
    const res = await ccSubmissionRepository.fetchOneSubmission(id)
    commit('setItem', get(res, 'data', {}))
    return res.data
  },
  async fetchOneSubmissionIndependent(_, id) {
    const res = await ccSubmissionRepository.fetchOneSubmission(id)
    return res.data
  },
  async fetchSubmissionLogs({commit}, {id, type = 'admin-update'}) {
    const res = await ccSubmissionRepository.fetchSubmissionLogs(id, {type})
    commit('setItemLogs', get(res, 'data', []))
    return res.data
  },
  async updateValidStateOfLevel(_, {id, ...data}) {
    const res = await ccSubmissionRepository.updateValidStateOfLevel(id, data)
    return res.data
  },
  async fetchSubmissions({commit}, params) {
    const res = await ccSubmissionRepository.fetchSubmissions(params)
    commit('setSubmissions', get(res, 'data', []))
    return res.data
  },
  async countSubmissions({commit}, params) {
    const res = await ccSubmissionRepository.countSubmissions(params)
    commit('setSubmissionCount', get(res, 'data', 0))
    return res.data
  },
  async fetchSubmissionsIndependent(_, params) {
    const res = await ccSubmissionRepository.fetchSubmissions(params)
    return res.data
  },
  async countSubmissionsIndependent(_, params) {
    const res = await ccSubmissionRepository.countSubmissions(params)
    return res.data
  },
  //
  async fetchWithRank({commit}, params) {
    const res = await ccSubmissionRepository.fetchWithRank(params)
    commit('setItems', get(res, 'data', []))
    return res.data
  },
  async searchWithRank({commit}, params) {
    const res = await ccSubmissionRepository.searchWithRank(params)
    commit('setItems', get(res, 'data', []))
    return res.data
  },
  async count({commit}, params) {
    const res = await ccSubmissionRepository.count(params)
    commit('setCount', get(res, 'data', 0))
    return res.data
  },
  // export
  async fetchWithRankIndependent(_, params) {
    const res = await ccSubmissionRepository.fetchWithRank(params)
    return res.data
  },
  async countIndependent(_, params) {
    const res = await ccSubmissionRepository.count(params)

    return res.data
  },
  //
}
const mutations = {
  setItem(state, item) {
    state.item = item
  },
  setItemLogs(state, logs) {
    state.itemLogs = logs
  },
  //
  setItems(state, items = []) {
    state.items = items
  },
  setCount(state, count) {
    state.count = count
  },
  //
  setSubmissions(state, items = []) {
    state.submissions = items
  },
  setSubmissionCount(state, count) {
    state.submissionCount = count
  },
}
const getters = {
  getItem: state => state.item,
  getItemLogs: state => state.itemLogs,
  //
  getItems: state => state.items,
  getCount: state => state.count,
  //
  getSubmissions: state => state.submissions,
  getSubmissionCount: state => state.submissionCount,
}
export default {
  state,
  actions,
  getters,
  mutations,
  namespaced: true,
}
